<template>
    <p>redirecting to vendor...</p>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            params: 'settings/get',
            provider: 'providers/selected',
        }),
    },
    methods: {
        isAuthenticated() {
            return (typeof this.params.userId !== 'undefined'
                    && this.params.userId !== null)
                || (typeof this.params.access_token !== 'undefined'
                    && this.params.access_token !== null);
        },
    },
    created() {
        if (this.isAuthenticated()) {
            switch (this.provider.name.toLowerCase()) {
            case 'vodacom':
                window.location.replace(`http://vodacom-staging.simplestreamcdn.com/?redirect_url=${
                    encodeURIComponent(`${window.location.origin}/vodacom`)
                }`)
                break
            case 'safaricom':
                this.$router.push({ name: 'Safaricom' })
                break
            case 'mtn':
                this.$router.push({ name: 'MTN' })
                break
            default:
                this.$router.push({ name: 'Account' })
            }
        } else {
            this.$router.push({ name: 'Register' })
        }
    },
}
</script>
